import useSWR from 'swr';
import { useBrandId } from 'AppProvider';
import buildReschedulableBookingsUrl from 'api/reschedule/buildReschedulableBookingsUrl';
import fetchReschedulableBookings from 'api/reschedule/fetchReschedulableBookings';

const fetchReschedulableBookingsSWR = async ([url, { brandId }]: [
  string,
  { brandId: string },
]) => fetchReschedulableBookings(url, { brandId });

const useReschedulableBookings = (
  cartId: string | undefined,
  {
    skip,
    token,
    languageCode,
  }: {
    skip: boolean;
    token: string | undefined;
    languageCode: string | undefined;
  },
) => {
  const brandId = useBrandId();
  const url = skip
    ? null
    : buildReschedulableBookingsUrl(cartId ?? '', {
        brandId,
        token,
        languageCode,
      });

  const swr = useSWR(
    url ? [url, { brandId }] : null,
    fetchReschedulableBookingsSWR,
  );

  return swr;
};

export default useReschedulableBookings;
